<template>
  <div v-frag>
    <span
      v-bind="$attrs"
      class="add-attache-btn"
      :style="style"
      @click.prevent="$refs.mediaUploader.click()"
    >
      <span v-if="mediaUploadProgress.isUploading">
        {{ (mediaUploadProgress.progress * 100).toFixed() }}%
      </span>
      <slot v-else></slot>
    </span>
    <input
      ref="mediaUploader"
      type="file"
      :style="{display: 'none'}"
      accept="audio/ogg|video/mp4|image/*|.pdf|.zip"
      multiple
      @change="onUploaderChanged"
    />
  </div>
</template>

<script>
  import axios from 'axios'
  import mediaMixins from '@/mixins/media.mixins'

  export default {
    name: 'MediaUploadBtn',
    mixins: [mediaMixins],
    props: {
      position: {
        type: String,
        default: 'static',
      },
      top: {
        type: String,
        default: undefined,
      },
      left: {
        type: String,
        default: undefined,
      },
      right: {
        type: String,
        default: undefined,
      },
      bottom: {
        type: String,
        default: undefined,
      }
    },
    data: () => ({
      formDataName: 'media',
      mediaUploadProgress: {
          loaded: 0,
          total: 0,
          progress: 0,
          isUploading: false,
        },
    }),
    computed: {
      style(){
        return {
          position: this.position,
          top: this.top,
          left: this.left,
          right: this.right,
          bottom: this.bottom,
        }
      }
    },
    methods: {
      async onUploaderChanged(event) {
        let { files } = event.target
        try {

            if (!files) {
              return false
            }

            if (typeof files === 'object') {
              files = Object.keys(files).map(i => files[i])
            }

            const formUpload = new FormData()

            files.forEach(file => {
              const check = this.mediaCheckLimits(file)
              if(check.isValid){
                formUpload.append(this.formDataName, file, file.name)
              } else {
                this.$toasted.info(check.message, { duration: 5000 })
              }
            })

            if(formUpload.getAll(this.formDataName).length === 0){
              return false
            }

            const response = await axios.post(axios.defaults.route + '/upload-media', formUpload, {
              headers: {
                'content-type': `multipart/form-data; boundary=${formUpload._boundary}`,
              },
              onUploadProgress: ({ loaded, total }) => {
                this.mediaUploadProgress =
                  loaded === total
                    ? {
                      loaded: 0,
                      total: 0,
                      progress: 0,
                      isUploading: false,
                    }
                    : {
                      loaded,
                      total,
                      progress: loaded / total,
                      isUploading: true,
                    }
              },
            })

          this.$emit('onUploaded', response.data)
          this.$toasted.success('File upload success!')
        } catch ({ data, statusText }) {
          this.$toasted.error(data.error || statusText)
        }
      },
    },
  }
</script>

<style>
  .add-attache-btn {
    cursor: pointer;
  }
</style>
